
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import {listClassification, listGender} from "../../../../../../data/list";
const { INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CURRENCY, NUMBER ,DATE_PRE,DATE_DISABLE_NO_DAY,SELECT} = FIELD_TYPE;
const TEL_NUMBER_REGEX = /^\d+$/;

const validatePhoneNumber = (rule, value) => {
  if (!TEL_NUMBER_REGEX.test(value)) {
    return Promise.reject("Chỉ cho phép nhập số");
  } else if (value.length > 11) {
    return Promise.reject("Số điện thoại tối đa 11 chữ số");
  } else if (value.length < 10) {
    return Promise.reject("Số điện thoại tối thiểu 10 chữ số");
  }else {
    return Promise.resolve();
  }
};
const listYears = [];
const currentYear = new Date().getFullYear();
const startYear = 1950;
const endYear = currentYear + 150;
for (let year = startYear; year <= endYear; year++) {
  listYears.push({
    value: year,
    label: year.toString(),
  });
}
const listMarriage = [
  {
    value: "0",
    label: "Chưa kết hôn",
  },
  {
    value: "1",
    label: "Sống chung chưa kết hôn",
  },
  {
    value: "2",
    label: "Đang có vợ/chồng",
  },
  {
    value: "3",
    label: "Góa",
  },
  {
    value: "4",
    label: "Ly thân",
  },
  {
    value: "5",
    label: "Ly hôn",
  },
];
const listNoiCap = [
  {
    value: "Sở Công an",
    label: "Sở Công An",
  },
  {
    value:"Cục cảnh sát đăng ký quản lý cư trú và dữ liệu quốc gia về dân cư",
    label:"Cục cảnh sát đăng ký quản lý cư trú và dữ liệu quốc gia về dân cư"
  },
  {
    value:"Cục cảnh sát quản lý hành chính về trật tự xã hội",
    label:"Cục cảnh sát quản lý hành chính về trật tự xã hội"
  }
]
const dataFields: DataFormField[] = [
  {
    type: SELECT,
    label: "Đợt tuyển dụng",
    name: "idDotTuyenDung",
    disable: false,
    rules: [{required: true, message: "Chưa nhập đợt tuyển dụng"}],
  },
  {
    type: COMBO_BOX,
    name: "viTriUngTuyen",
    label: "Vị trí ứng tuyển",
    disable: false,
  },
  {
    type: INPUT,
    name: "viTriUngTuyenTA",
    label: "Vị trí ứng tuyển TA",
    disable: false,
  },
  {
    type: INPUT,
    name: "hoTen",
    label: "Họ tên",
    disable: false,
    rules: [{required: true, message: "Chưa nhập họ và tên"}],

  },
  {
    type: DATE_DISABLE_NO_DAY,

    name: "ngaySinh",
    label: "Ngày sinh",
    disable: false,
    disableDate:false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },

  },
  {
    type: COMBO_BOX,
    name: "gioiTinh",
    label: "Giới tính",
    disable: false,
    options: listGender,

  },
  {
    type: INPUT,
    name: "hoKhauThuongTru",
    label: "Hộ khẩu thường trú",
    disable: false,

  },  {
    type: INPUT,
    name: "nguyenQuan",
    label: "Nguyên quán",
    disable: false,

  },
  {
    type: COMBO_BOX,

    name: "quocTich",
    label: "Quốc tịch",
    disable: false,
    disableDate:false,

  },
  {
    type: INPUT,

    name: "nuocCuTru",
    label: "Nước cư trú",
    disable: false,
    disableDate:false,

  },
  {
    type: INPUT,

    name: "dienThoaiDiDong",
    label: "Điện thoại",
    disable: false,
    disableDate:false,
    // rules: [
    //   {
    //     validator: validatePhoneNumber,
    //   },
    // ],
    rules: [
      {
        pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        message: "Chỉ cho phép nhập số",
      },
      {
        max: 11,
        min: 10,
        message: "Định dạng SĐT không đúng",
      },
    ],
  },
  {
    type: INPUT,
    name: "email",
    label: "Email",
    disable: false,
    rules: [
      {
          pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 
          message: "Định dạng email không đúng"
      }
  ]
  },
  {
    type: INPUT,
    name: "cccd",
    label: "Số CMT/CCCD/Hộ chiếu",
    disable: false,
  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "ngayCap",
    label: "Ngày cấp",
    disable: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },

  },
  {
    type: COMBO_BOX,
    name: "noiCap",
    label: "Nơi cấp ",
    disable: false,
    options: listNoiCap,
    css: {
      xl: 16,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
  },
  
  {
    type: COMBO_BOX,
    name: "danToc",
    label: "Dân tộc",
    disable: false,

  },
  {
    type: SELECT,
    name: "tonGiao",
    label: "Tôn giáo",
    disable: false,

  },
  {
    type: COMBO_BOX,
    name: "tinhTrangHonNhan",
    label: "TT hôn nhân",
    disable: false,
    options: listMarriage,

  },
  {
    type: INPUT,
    name: "ngonNgu",
    label: "Ngôn ngữ",
    disable: false,

  },
  {
    type: CURRENCY,
    name: "mucLuong",
    label: "Mức lương",
    disable: false,

  },
  {
    type: DATE_DISABLE_NO_DAY,
    name: "ngayNopHoSo",
    label: "Ngày nộp hồ sơ",
    disable: false,
    optionsTime: { showTime: true, format: FORMAT_TIME.dayFull },
  },
  {
    type: COMBO_BOX,
    name: "trinhDo",
    label: "Trình độ",
    disable: false,
    options:[
      {
        value: "Đại học",
        label: "Đại học",
      },
      {
        value: "Cao đẳng",
        label: "Cao đẳng",
      },
      {
        value: "Chưa xác định",
        label: "Chưa xác định",
      },
    ]
  },
  {
    type: INPUT,
    name: "totNghiepTruong",
    label: "Tốt nghiệp trường",
    disable: false,
    css: {
      xl: 16,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
  },
  {
    type: COMBO_BOX,
    name: "namTotNghiep",
    label: "Năm tốt nghiệp",
    disable: false,
    options: listYears,

  },
  {
    type: COMBO_BOX,
    name: "xepLoai",
    label: "Xếp loại",
    disable: false,
    options: listClassification,
    css: {
      xl: 16,
      lg: 12,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10, md: 8, lg: 8, xl: 3 },
    wrapperCol: { xs: 14, md: 16, lg: 16, xl: 21 },
  },
  {
    type: INPUT,
    name: "ghiChu",
    label: "Ghi chú",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10,md: 8, lg: 4, xl: 2 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },

  },
  {
    type: INPUT,
    name: "fileCV",
    label: "CV đính kèm",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10,md: 8, lg: 4, xl: 2 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },

  },


];
const field: DataFormField[] = [
  {
    type: INPUT,
    name: "ketQuaPhongVan",
    label: "Kết quả phỏng vấn",
    disable: false,
    css: {
      xl: 24,
      lg: 24,
      md: 24,
      sm: 24,
      xs: 24,
    },
    labelCol: { xs: 10,md: 8, lg: 4, xl: 2 },
    wrapperCol: { xs: 14, md: 16, lg: 20, xl: 22 },

  },
];
export {field,dataFields , validatePhoneNumber};

